export const UserRole = {
    "userRole" : localStorage.getItem('role'),
}